import { useState, useEffect } from "react";
import {
  Badge,
  Button,
  Card,
  CardHeader,
  CardFooter,
  Table,
  Container,
  Row,
  Col,
  Pagination,
  PaginationItem,
  PaginationLink,
  Input
} from "reactstrap";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import "ag-grid-community/dist/styles/ag-theme-alpine-dark.css";
import "../../assets/css/custom.css";
import Header from "components/Headers/Header.js";
import { taskmanageService } from "../../services/taskmanageService";
import { clientmanageService } from "../../services/clientmanageService";
import 'assets/css/themecustom-style.css';
import Paginationcomponent from "components/Paginationcomponent.js";
import { toast } from 'react-toastify';
const CompaniesHouseFiling = (props) => {
  const [currentPage, setCurrentPage] = useState(null);
  const [last_page, setLastPageData] = useState(0);
  const [data, setData] = useState([]);
  const [rowsPerPage, setRowsPerPage] = useState(25);
  const [total_page,setTotalData] = useState(0);
  const rowsPerPageOptions = [5, 10, 25, 50, 100];
  const [filtertype,setfiltertype] = useState('total');
  const [filterFields,setfilterFields] = useState([]);

  const user_info = JSON.parse(localStorage.getItem("user-info"));
  const handlePageClick = (e, index) => {
    e.preventDefault();
    get_list(index,rowsPerPage);
  };

  const handlePreviousClick = () => {
    const prev = currentPage - 1;
    get_list(prev,rowsPerPage);
  };

  const handleNextClick = () => {
    const next = currentPage + 1;
    get_list(next,rowsPerPage);
  };
    const [sortfield,setsortfield] = useState('');
    const [sortorder,setsortorder] = useState('asc'); 
    function sortTable(field){
    console.log(field)
    setsortfield(field);
    if(sortorder=='asc'){
      setsortorder('desc');
    }else{
      setsortorder('asc');
    }
  } 
const[statusCountData,setStatusCountData]=useState([]);
  const get_list = async (pageNumber = 1,rowsPerPage='',filtertype='total',filterFields) => { 
   
    taskmanageService.getcompaniesHouseFilingData(pageNumber,rowsPerPage,filtertype,filterFields,sortfield,sortorder).then((response) => {
      
        setData(response.data.data.data);
      setCurrentPage(response.data.data.current_page);
      setLastPageData(response.data.data.last_page);
      setTotalData(response.data.data.total);
      setStatusCountData(response.data.statusData);
    });
  };

  const restoreTask = (id,index) => {
    taskmanageService.restoreTask(id).then((response) => {
      if(response.status == 200){
        let state = [...archivedata];
        delete state[index];
        setArchivedata(state);
       toast.success(response.data.message);
      }else{
        toast.error(response.data.message);
      }
    });
  }

  const formatDate = (dateStr) => {
    if(dateStr!=null && dateStr!=''){
      const [year, month, day] = dateStr.split('-');
      let newDate = `${day}-${month}-${year}`;
      return newDate;
    }
  };

  useEffect(() => {
    get_unique_companieslist()
    get_list();
    get_unique_companieslist()
}, [sortorder]);

const handleRowsPerPageChange = (newRowsPerPage) => {

  setRowsPerPage(newRowsPerPage);
  
  setCurrentPage(1); 
  get_list(1,newRowsPerPage)

};
  const editField = (value, field, id,index) => {
    taskmanageService.editCompaniesHousefilingRow(value, field, id).then((response) => {
     
      let temp_st = [...data];
      let temp_ele = { ...temp_st[index] };
      if(response.status == 200){
        toast.success(response.data.message);
      }else{
          toast.error(response.data.message);
      }
      temp_ele.editing = false;
      temp_ele[field] = value;
      temp_st[index] = temp_ele;
      setData(temp_st);
      get_list(1,'',filtertype)
    })
  }
  const handleeditRow = (index) => {
    // if(phaseedit == true || taskedit == true || analystedit == true){
      let temp_state = [...data];
      let temp_element = { ...temp_state[index] };
      temp_element.editing = true;
      temp_state[index] = temp_element;
      setData(temp_state);
      // }

  };


  const [uniquecompanieslist, setUniqueCompaniesData] = useState([]);
  function get_unique_companieslist(){
   clientmanageService.getclientlist().then((response)=>{
      setUniqueCompaniesData(response.data);
    });
  }
  const [ subclientlist, setsubclientlist ] = useState([])
  
    function subclientList(clientname=''){
      clientmanageService.getsubclientlist(clientname).then((response) => {
          if(response.status === 200){
            setsubclientlist(response.data)
          }else {
            toast.error('Something went wrong!');
          }
      });
    }
    function setclient(e){
      subclientList(e.target.value)
      // var index = e.target.selectedIndex;
      // setclientsearch(e.target[index].text)
      setclientsearch(e.target.value);
    //   const cloneValues = {...filterFields};
    //   delete cloneValues[2];
    //  setfilterFields(cloneValues);
    }
    // const [allclient, setAllclient] = useState(true);
    // const [clientsearch, setclientsearch] = useState('');
    // const companyfilter = (e,index) => {
    //   if(e.target.value == ''){
    //     setAllclient(true);
    //   }else{
    //     setAllclient(false);
    //   }
    //   const cloneValues = {...filterFields};
    //   cloneValues[index] = {
    //     ...cloneValues[index],
    //     ['field']: e.target.name,
    //     ['value']: encodeURIComponent(e.target.value),
    //     ['operator']: '='
    //   };
    //   setfilterFields(cloneValues);
    //   get_list(1,'',filtertype,cloneValues);
    // }
      function subclientList(clientname=''){
        clientmanageService.getsubclientlist(clientname).then((response) => {
            if(response.status === 200){
              setsubclientlist(response.data)
            }else {
              toast.error('Something went wrong!');
            }
        });
      }
      function setclient(e){
        subclientList(e.target.value)
        // var index = e.target.selectedIndex;
        // setclientsearch(e.target[index].text)
        setclientsearch(e.target.value);
        const cloneValues = {...filterFields};
       // delete cloneValues[2];
        console.log(cloneValues)
       //setfilterFields(cloneValues);
      }
      const [allclient, setAllclient] = useState(true);
      const [clientsearch, setclientsearch] = useState('');

      const companyfilter = (e, index) => {
        const value = encodeURIComponent(e.target.value);
        setAllclient(value === '');
      
        const updatedFilters = {
          ...filterFields,
          [index]: {
            field: e.target.name,
            value,
            operator: '='
          }
        };
      
        setfilterFields(updatedFilters);
        get_list(1, '', filtertype, updatedFilters); // ✅ Don't rely on old state
      };
      
      function downloadReport() {
        console.log('Sending filters:', filterFields);
      
        const cleanedFilters = Object.keys(filterFields).reduce((acc, key) => {
          acc[key] = filterFields[key];
          return acc;
        }, {});
      
        taskmanageService.download_companies_house_report(filtertype, cleanedFilters)
          .then((response) => {
            console.log('Download successful');
          });
      }
      
  
  return (
    <>
      <Header />
      <Container className="mt--7" fluid>
        
      <Row className="filter" style={{padding:'0 3%'}}>
                    <h3 className="mb-0" style={{fontSize:'20px'}}>Companies House Filing List</h3><br></br>
                    <br></br>
                </Row>
        <Row className="">
          <div className="col" style={{padding:'0%'}}>
            <Card className="shadow">
              <CardHeader className="border-0">
                
                {/* <Row > */}
{/*                     
          <button type="button" style={filtertype == 'pending' ?
          { backgroundColor:'#5d6cae',color:'#fff',fontFamily:'inherit',margin: '7px 0px'} : {fontFamily:'inherit',margin: '7px 0px'}} onClick={() =>{setfiltertype('pending'); get_list(1,'','pending',filterFields)}} className=" btn btn-secondary text-center">
            Pending
            {(statusCountData) ? 
            <Badge title="Approval Pending" className="badge-circle" color="danger" size="sm" style={{"position": "absolute","right": "-5px","bottom": "-7px","height":"1.0rem","width":"1.0rem","fontSize":"10px","color": "#fff","backgroundColor": "red"}}>
              {statusCountData.pending_tasks}
            </Badge> : null }
          </button>&nbsp;
          <button type="button" style={filtertype == 'completed' ?
          { backgroundColor:'#5d6cae',color:'#fff',fontFamily:'inherit',margin: '7px 0px'} : {fontFamily:'inherit',margin: '7px 0px'}} onClick={() => {setfiltertype('completed'); get_list(1,'','completed',filterFields)}}  className=" btn btn-secondary text-center">
            Completed
            {(statusCountData ) ? 
            <Badge title="Approval Pending" className="badge-circle" color="danger" size="sm" style={{"position": "absolute","right": "-8px","bottom": "-7px","height":"1.0rem","width":"1.0rem","fontSize":"10px","color": "#fff","backgroundColor": "red"}}>
              {statusCountData.completed_tasks}
            </Badge> : null }
          </button>  &nbsp;&nbsp;
          <button type="button" style={filtertype == 'archive' ?
          { backgroundColor:'#5d6cae',color:'#fff',fontFamily:'inherit',margin: '7px 0px'} : {fontFamily:'inherit',margin: '7px 0px'}} onClick={() =>  {setfiltertype('archive'); get_list(1,'','archive',filterFields)}} className=" btn btn-secondary text-center">
            Not Applicable
            {(statusCountData) ? 
            <Badge title="Approval Pending" className="badge-circle" color="danger" size="sm" style={{"position": "absolute","right": "-8px","bottom": "-7px","height":"1.0rem","width":"1.0rem","fontSize":"10px","color": "#fff","backgroundColor": "red"}}>
              {statusCountData.archive_tasks}
            </Badge> : null }
           
          </button>&nbsp;&nbsp;
         */}
          {/* <button type="button" style={{fontFamily:'inherit',margin: '7px 0px'}} onClick={() => downloadReport(filterFields)} className=" btn btn-secondary text-center">
          <i className="fas fa-download" style={{fontSize:'14px'}}></i> Export
          </button> */}
        
        <Row className="dash-analy">
        <Col xl="1" md="6" xs="12"  className="dash-col-analy" style={{maxWidth:'40%'}}>
                <Row className={(filtertype=='total' ? "align-items-center dash-inner-row active" : "align-items-center dash-inner-row")}>
                  <div className="col" onClick={() => {get_list(1,'','total',filterFields),setfiltertype('total')}}>
                    {/* <h6 className="text-uppercase text-muted text-dash ls-1 mb-1">
                      Total
                    </h6> */}
                    <h1 style={{ color: "#0060B8" }}>
                      {statusCountData.total_tasks}
                    </h1>
                    <h3 className="mb-0" style={{ color: "#0060B8" }}>
                      Total 
                    </h3>
                  </div>
                </Row>
             
          </Col>
          
          <Col xl="1" md="6" xs="12"  className="dash-col-analy" style={{maxWidth:'40%'}}>
                <Row className={(filtertype=='pending' ? "align-items-center dash-inner-row active" : "align-items-center dash-inner-row")}>
                  <div className="col" onClick={() => {get_list(1,'','pending',filterFields),setfiltertype('pending')}}>
                    {/* <h6 className="text-uppercase text-muted text-dash ls-1 mb-1">
                      Total
                    </h6> */}
                    <h1 style={{ color: "#FF8C00" }}>
                      {statusCountData.pending_tasks}
                    </h1>
                    <h3 className="mb-0" style={{ color: "#FF8C00" }}>
                      Pending
                    </h3>
                  </div>
                </Row>
             
          </Col>
          
          
        
          <Col xl="1" md="6" xs="12" className="dash-col-analy" style={{maxWidth:'40%'}}>
             <Row  className={(filtertype=='completed' ? "align-items-center dash-inner-row active" : "align-items-center dash-inner-row")}>
                  <div className="col" onClick={() => {get_list(1,'','completed',filterFields),setfiltertype('completed')}}>
                    {/* <h6 className="text-uppercase text-muted text-dash ls-1 mb-1">
                      Completed
                    </h6> */}
                    <h1 style={{ color: "#0DAF84" }}>
                      {statusCountData.completed_tasks}
                    </h1>
                    <h3 style={{ color: "#0DAF84" }} className="mb-0">
                      Completed 
                    </h3>
                  </div>
                </Row>
           
          </Col> 
          <Col xl="1" md="6" xs="12"  className="dash-col-analy" style={{maxWidth:'40%'}} >
           
                <Row className={(filtertype=='archive' ? "align-item-s-center dash-inner-row active" : "align-items-center dash-inner-row")}>
                  <div className="col" onClick={() => {get_list(1,'','archive',filterFields),setfiltertype('archive')}}>
                    {/* <h6 className="text-uppercase text-muted text-dash ls-1 mb-1">
                      Pending
                    </h6> */}
                    <h1 style={{ color: "#FF1717" }}>
                      {statusCountData.archive_tasks}
                    </h1>
                    <h3 className="mb-0" style={{ color: "#FF1717" }}>
                    Not Applicable 
                    </h3>
                  </div>
                </Row>
             
          </Col>
        </Row>
        <br></br>
        <Row>
        <div className="col-xl-2 col-md-2 col-xs-12">
                  <h5 className="clientformtag"> Client</h5>
                        {(uniquecompanieslist.length > 0 && (user_info.role_id != 13))?
                              <select className="form-control" name="company" onChange={(e) => { companyfilter(e,1),setclient(e);}}   >
                                  <option value="" key="al_key_1">All Clients</option>
                                  {(uniquecompanieslist).map((valuel,k) =>
                                      <option key={k} value={valuel.name}>
                                        {valuel.name}
                                      </option>
                                  )}
                              </select>
                            : null }
                        </div>
                        <div className="col-xl-2 col-md-2 col-xs-12">
                          <h5 className="clientformtag">Sub Client</h5>
                            <select  class="form-control" name="sub_client"  onChange={(e) => companyfilter(e,2)}>
                              <option value=""> Select Sub Client</option>
                              {subclientlist.map(res => (
                                  <option
                                    key={res.sub_client}
                                    value={res.sub_client}
                                  >
                                    {res.sub_client}
                                  </option>
                                ))}
                            </select>
                        </div>
                        <div className="col-xl-2 col-md-2 col-xs-12">
                        <h5 className="clientformtag"></h5>
                        <button type="button" style={{fontFamily:'inherit',margin: '7px 0px'}}  onClick={downloadReport} className=" btn btn-secondary text-center">
          <i className="fas fa-download" style={{fontSize:'14px'}}></i> Export
          </button></div>
        </Row>
        <br></br>
              </CardHeader>
              <Table className="align-items-center table-flush" responsive>
                <thead className="thead-light">
                    <th scope="col" onClick={(e) => sortTable('name')}>Main Client</th>
                    <th scope="col"  onClick={(e) => sortTable('sub_client')}>Sub Client</th>
                    {filtertype=='pending' ?
                    <th scope="col">Companies House Filing</th>: null}
                    <th scope="col">Authentication No</th>
                    <th scope="col">Company Registration No</th> 
                    <th scope="col">Year End</th>
                    <th scope="col">Accounts Type</th>
                    {filtertype!='archive' ?
                    <th scope="col">Status</th>
                    : null }
                </thead>
                <tbody>
                  {data &&
                    data.length &&
                    data != null ? (
                        data.map((item, i) => (
                      <>
                     <tr className={((i % 2 == 0)? 'blue-row':(i % 3 == 0)?'purple-row':'orange-row') }>
                        <td>{item.name}</td>
                        <td>{item.sub_client}</td>
                        {filtertype=='pending' ? 
                        <td onClick={()=> handleeditRow(i,'companieshouse_filing')}>
                        {item.editing ? (
                    <select
                                className="form-control"
                                 onChange={(e) =>
                                  editField(
                                    e.target.value,
                                    "companieshouse_filing",
                                    item.id,
                                    i
                                  )
                                }
                        defaultValue={item.companieshouse_filing}
                        >
                        <option value="">select</option>
                        <option value="yes">Yes</option>
                        <option value="no">No</option>
                        </select>):<span>{item.companieshouse_filing}</span>}
                        </td>:null}
                        
                        <td onClick={()=> handleeditRow(i,'authentication_no')} >
                            {item.editing ? (
                              <input type="text"
                              className="form-control"
                              defaultValue={item.authentication_no}
                              
                                onBlur={(e) =>
                                  editField(
                                    e.target.value,
                                    "authentication_no",
                                    item.id,
                                    i
                                  )
                                }
                               
                              />
                            ) : (
                              <span>{item.authentication_no}</span>
                            )}
                          </td>
                        <td onClick={()=> handleeditRow(i,'company_registration_no')} >
                            {item.editing ? (
                              <input type="text"
                              className="form-control"
                              defaultValue={item.company_registration_no}
                              
                                onBlur={(e) =>
                                  editField(
                                    e.target.value,
                                    "company_registration_no",
                                    item.id,
                                    i
                                  )
                                }
                               
                              />
                            ) : (
                              <span>{item.company_registration_no}</span>
                            )}
                          </td>
                        <td onClick={()=> handleeditRow(i,'year_end_date')} >
                            {item.editing ? (
                              <input type="date"
                              className="form-control"
                              defaultValue={item.year_end_date}
                              
                                onBlur={(e) =>
                                  editField(
                                    e.target.value,
                                    "year_end_date",
                                    item.id,
                                    i
                                  )
                                }
                                
                              />
                            ) : (
                              <span>{item.year_end_date}</span>
                            )}
                          </td>
                          <td className="whitespace" onClick={()=> handleeditRow(i,'accounts_type')}> 
                              {item.editing  ? (
                    <select
                                className="form-control"
                                onChange={(e) =>
                                  editField(
                                    e.target.value,
                                    "accounts_type",
                                    item.id,
                                    i
                                  )
                                }
                                defaultValue={item.accounts_type}
                              >
                                <option value="Dormant" key="0" >Dormant</option>
                                <option value="Macro">Macro</option>
                               
                              </select>   ) : item.accounts_type}
                              </td> 
                              {filtertype!='archive' ?
                            <td onClick={()=> handleeditRow(i,'status')}>
                            {item.editing ? (
                            <select
                                className="form-control"
                                onChange={(e) =>
                                  editField(
                                    e.target.value,
                                    "status",
                                    item.id,
                                    i
                                  )
                                }
                                defaultValue={item.status}
                              >
                                <option value="0" key="0" style={{background:'#fff',color:'#000'}}>Select Status</option>
                               
                                      <option key="1" value="1">Pending</option>
                                      <option key="3" value="3">Completed</option>
                                 
                              </select> ) : (
                                <p onClick={()=> handleeditRow(i,'status')}>{item.status_name}</p>
                              )}
                          </td> 
                          : null }
                     </tr>
                      
                      </>
                    ))
                  ) : (
                    <tr>
                      <td colSpan={3}>No Data Found!</td>
                    </tr>
                  )}
                </tbody>
              </Table>

              <CardFooter className="py-4">
                <nav aria-label="...">
                  <Pagination
                    className="pagination justify-content-end mb-0"
                    listClassName="justify-content-end mb-0"
                  >
                    <PaginationItem disabled={currentPage <= 1}>
                      <PaginationLink onClick={handlePreviousClick} previous />
                    </PaginationItem>
                    {[...Array(last_page)].map((page, i) => (
                      <PaginationItem
                        active={i + 1 === currentPage}
                        key={i + 1}
                      >
                        <PaginationLink
                          onClick={(e) => handlePageClick(e, i + 1)}
                        >
                          {i + 1}
                        </PaginationLink>
                      </PaginationItem>
                    ))}
                    <PaginationItem disabled={currentPage >= last_page}>
                      <PaginationLink onClick={handleNextClick} next />
                    </PaginationItem>
                  </Pagination>
                </nav>
              </CardFooter>
            </Card>
          </div>
        </Row>
      
      </Container>
    </>
  );
};


export default CompaniesHouseFiling;
